import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73038d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upUnit" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("源文件 ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (或者")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pointer",
  style: {"color":"rgb(11, 170, 240)"}
}, "点击引用", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("已上传的源文件) ")
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("选择源文件")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = { class: "upUnit" }
const _hoisted_15 = { class: "mb-10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("PO文件 ")
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" (或者")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pointer",
  style: {"color":"rgb(11, 170, 240)"}
}, "点击引用", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("已上传的PO文件) ")
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("选择PO文件")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_27 = { class: "upUnit" }
const _hoisted_28 = { class: "mb-10" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("交付凭证（如邮件、微信截图）")
const _hoisted_32 = {
  key: 0,
  class: "cornerLink"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖拽到此处或"),
  /*#__PURE__*/_createElementVNode("em", null, "单击上传"),
  /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传源文件，文件格式无限制，且最大上传文件大小200M。 ")
], -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖拽到此处或"),
  /*#__PURE__*/_createElementVNode("em", null, "单击上传"),
  /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传PO文件，文件格式无限制，且最大上传文件大小200M。 ")
], -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖拽到此处或"),
  /*#__PURE__*/_createElementVNode("em", null, "单击上传"),
  /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传交付凭证，文件格式无限制，且最大上传文件大小200M。 ")
], -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_47 = { class: "mt-30" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-30" }, "提示:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 勾选并引用其他订单已上传的源文件，点击确定后，被勾选的文件自动上传到当前订单下。", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("2. 此功能仅适用于相同源文件多个订单的情况下，"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "请勿引用与此订单不相关的源文件。")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 若本次批量交付的订单均未上传源文件，则上方列表为空。", -1))
const _hoisted_52 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_54 = { class: "mt-30" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-30" }, "提示:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 勾选并引用其他订单已上传的PO文件，点击确定后，被勾选的文件自动上传到当前订单下。", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("2. 此功能仅适用于相同源文件多个订单的情况下，"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "请勿引用与此订单不相关的PO文件。")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 若本次批量交付的订单均未上传源文件，则上方列表为空。", -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_61 = { class: "mt-30" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-30" }, "提示:", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1. 勾选并引用其他订单已上传的交付凭证，点击确定后，被勾选的文件自动上传到当前订单下。", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("2. 此功能仅适用于相同交付凭证多个订单的情况下，"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "请勿引用与此订单不相关的交付凭证。")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3. 若本次批量交付的订单均未上传交付凭证，则上方列表为空。", -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_68 = { style: {"white-space":"pre","color":"red"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 是否继续交付？若继续交付，系统将会暂存上述订单已上传的文件，并交付满足交付条件的订单。 ")
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 或者点击取消继续上传文件 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("继续交付")

import { ref, Ref, reactive, onBeforeMount, shallowRef, onBeforeUnmount, nextTick, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, formatFileSize } from '@/utils/index'
import {axiosInstance} from '@/http/index'
import '@wangeditor/editor/dist/css/style.css'
import { DomEditor } from '@wangeditor/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    orderList: null,
    isEdit: { type: Boolean }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  orderList: any[],
  isEdit?: boolean
}

const {
  // 订单交付_上传
  'POST/order/delivery/upload': uploadApi,
  // 获取文件(未交付)
  'GET/order/delivery/{id}': orderFileApi,
  // 获取文件(已交付)
  'GET/order/delivered/{no}': getDeliveredFileApi,
  // 订单交付
  'DELETE/order/delivery/delete_file': delete_fileApi,
  // 订单交付
  'POST/order/delivery/referenced_file': referenced_fileApi,
  // 交付凭证富文本框_图片文件上传
  'POST/order/delivery/upload_file': deliveryUpload_fileApi,
} = Api


const formatOrderFiles = (row: any) => {
  row.isLoading = true

  let promiseLink = Promise.resolve()
  if(props.isEdit === true){
    promiseLink = getDeliveredFileApi({no: row.no})
  } else {
    promiseLink = orderFileApi({id: row.no})
  }
  promiseLink.then((rep: any) => {
    let { sourceFiles, poFiles, deliveryFiles, poFileNote } = rep
    // 文件
    row.sourceFiles = sourceFiles?.filter((file: {type: string}) => file.type === 'FILE_ID' ) || []
    row.poFiles = poFiles?.filter((file: {type: string}) => file.type === 'FILE_ID' ) || []
    row.deliveryFiles = deliveryFiles?.filter((file: {type: string}) => file.type === 'FILE_ID' ) || []

    /* row.sourceFileNote = sourceFileNote || ''
    row.poFileNote = poFileNote || ''
    row.deliveryNote = deliveryNote || '' */
    // 富文本框内容
    row.sourceFileNote = sourceFiles?.filter((file: {type: string}) => file.type !== 'FILE_ID' ).reverse()[0]?.deliveryValue || ''
    row.poFileNote = poFiles?.filter((file: {type: string}) => file.type !== 'FILE_ID' ).reverse()[0]?.deliveryValue || ''
    row.deliveryNote = deliveryFiles?.filter((file: {type: string}) => file.type !== 'FILE_ID' ).reverse()[0]?.deliveryValue || ''


  }).finally(() => {
    row.isLoading = false
  })
}

const isListLoading = ref<boolean>(false)
onBeforeMount(() => {
  props.orderList.map((order: {id: string}) => {
    formatOrderFiles(order)
  })
})




const currentOrder: any = reactive({
  sourceFiles: [],
  poFiles: [],
  poFileNote: '',
  deliveryFiles: [],
})
let currentOrderRow = {}
const upPercentage = ref<number>(0)
let cancelTk = axiosInstance.CancelToken.source()


// 上传源文件
const isShowUpFile = ref<boolean>(false)
const showUpFileHandle = (_order: any) => {
  isShowUpFile.value = true
  Object.assign(currentOrder, _order, {sourceFiles: []})
  currentOrderRow = _order

}
const upFileHandle = () => {
  // 判断是否有选择源文件
  if(currentOrder.sourceFiles.length === 0){
    ElMessage.warning('请至少选择一个源文件')
    return
  }
  cancelTk = axiosInstance.CancelToken.source();

  const form: any = new FormData()
  form.append('no', currentOrder.no)
  form.append('deliveryFileType', 'SOURCE_FILE')
  currentOrder.sourceFiles.map((file: any) => {
    form.append('sourceFiles', file.raw)
  })
  uploadApi(
    form, 
    {
      onUploadProgress: (progessEve: {loaded: number, total: number}) => {
        upPercentage.value = Number((progessEve.loaded / progessEve.total * 100).toFixed(2))
      },
      cancelToken: cancelTk.token
  }).then(() => {
    ElMessage.success('上传成功')
    isShowUpFile.value = false
    formatOrderFiles(currentOrderRow)
  }).finally(() => {
    upPercentage.value = 0
  })

}

// 上传PO
const isShowUpPo = ref<boolean>(false)
const showUpPoHandle = (_order: any) => {
  isShowUpPo.value = true
  Object.assign(currentOrder, _order, {poFiles: []})
  currentOrderRow = _order
}
const upPoHandle = () => {
  // 判断是否有选择PO文件
  if(currentOrder.poFiles.length === 0){
    ElMessage.warning('请至少选择一个PO文件')
    return
  }
  cancelTk = axiosInstance.CancelToken.source();

  const form: any = new FormData()
  form.append('no', currentOrder.no)
  form.append('deliveryFileType', 'PO_FILE')
  currentOrder.poFiles.map((file: any) => {
    form.append('poFiles', file.raw)
  })
  uploadApi(
    form, 
    {
      onUploadProgress: (progessEve: {loaded: number, total: number}) => {
        upPercentage.value = Number((progessEve.loaded / progessEve.total * 100).toFixed(2))
      },
      cancelToken: cancelTk.token
  }).then(() => {
    ElMessage.success('上传成功')
    isShowUpPo.value = false
    formatOrderFiles(currentOrderRow)
  }).finally(() => {
    upPercentage.value = 0
  })

}

// 上传交付凭证
const isShowDeliver = ref<boolean>(false)
const showDeliverHandle = (_order: any) => {
  isShowDeliver.value = true
  Object.assign(currentOrder, _order, {deliveryFiles: []})
  currentOrderRow = _order
}
const upDeliverHandle = () => {
  // 判断是否有选择PO文件
  if(currentOrder.deliveryFiles.length === 0){
    ElMessage.warning('请至少选择一个交付凭证')
    return
  }
  cancelTk = axiosInstance.CancelToken.source();

  const form: any = new FormData()
  form.append('no', currentOrder.no)
  form.append('deliveryFileType', 'DELIVERY_FILE')
  currentOrder.deliveryFiles.map((file: any) => {
    form.append('deliveryFiles', file.raw)
  })
  uploadApi(
    form, 
    {
      onUploadProgress: (progessEve: {loaded: number, total: number}) => {
        upPercentage.value = Number((progessEve.loaded / progessEve.total * 100).toFixed(2))
      },
      cancelToken: cancelTk.token
  }).then(() => {
    ElMessage.success('上传成功')
    isShowDeliver.value = false
    formatOrderFiles(currentOrderRow)
  }).finally(() => {
    upPercentage.value = 0
  })

}

// 上传PO备注
const submitPoFileNote = (order: any) => {
  uploadApi({
    no: order.no,
    poFileNote: order.poFileNote,
  }, {contentType: 'formData'}).then(() => {
    ElMessage.success('保存成功')
    formatOrderFiles(order)
  })
}

// 删除文件
const delFileHandle = (order: any, row: any) => {
  // 删除文件
  ElMessageBox.confirm(`请确认是否删除:${row.file.filename}?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    row.isLoading = true
    return delete_fileApi({
      deliveryRecordId: row.id
    }, {contentType: 'formData'})
  }).then(() => {
    row.isLoading = false
    ElMessage.success('删除成功')
    formatOrderFiles(order)
  }).catch(() => {
    row.isLoading = false
  })
}


let referenceRows: any = ref([])
let referenceTbEle: any = ref([])
const setTbRef = (el: any) => {
  referenceTbEle.value.push(el)
}
const clearTableHandle = () => {
  // 清空多选
  referenceTbEle.value.map((tbEle: any) => {
    tbEle?.clearSelection()
  })
  referenceRows.value = []
}




const referenceRowsChange = (rows: any, index: number) => {
  referenceRows.value[index] = rows
}






// 引用源文件
const isShowHisFile = ref<boolean>(false)
const showHisFileHandle = (_order: any) => {
  referenceTbEle.value = []
  Object.assign(currentOrder, _order)
  currentOrderRow = _order
  isShowHisFile.value = true
}

// 引用PO文件
const isShowHisPo = ref<boolean>(false)
const showHisPoHandle = (_order: any) => {
  referenceTbEle.value = []
  Object.assign(currentOrder, _order)
  currentOrderRow = _order
  isShowHisPo.value = true
}

// 全部引用交付凭证
const isAllQuote = ref<boolean>(false)
const isShowHisDelivery = ref<boolean>(false)
const showHisDeliveryHandle = (_order: any) => {
  if(!isAllQuote.value){
    // 取消全部引用
    ElMessageBox.confirm('是否除订单一外，清空交付凭证?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      tyep: 'warning'
    }).then(() => {
      isListLoading.value = true
      return referenced_fileApi({
        orderNo: props.orderList[0].no,
        referencedOrderNo: props.orderList.filter((row: {no: string}) => row.no !== props.orderList[0].no).map(e => e.no),
        isDelete: true,
      })
    }).then(() => {
      ElMessage.success('清空成功')
      props.orderList.map((order: {id: string}) => {
        formatOrderFiles(order)
      })
    }).catch(() => {
      isAllQuote.value = !isAllQuote.value
    }).finally(() => {
      isListLoading.value = false
    })
    return
  }

  ElMessageBox.confirm('是否全部订单使用订单一交付凭证?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    tyep: 'warning'
  }).then(() => {
    isListLoading.value = true
    return referenced_fileApi({
      orderNo: props.orderList[0].no,
      referencedOrderNo: props.orderList.filter((row: {no: string}) => row.no !== props.orderList[0].no).map(e => e.no),
      isDelete: false,
    })
  }).then(() => {
    ElMessage.success('引用成功')
    props.orderList.map((order: {id: string}) => {
      formatOrderFiles(order)
    })
  }).catch(() => {
    isAllQuote.value = !isAllQuote.value
  }).finally(() => {
    isListLoading.value = false
  })
}

// 确认引用
const isRefLoading = ref<boolean>(false)
const confirmReference = (fileType: string) => {
  const arr = referenceRows.value.flat()
  if(arr.length === 0){
    ElMessage.warning('请至少选择一条引用文件')
    return
  }
  isRefLoading.value = true
  uploadApi({
    no: currentOrder.no,
    [fileType]: arr.map((file: any) => file.deliveryValue).join(',')
  }, {contentType: 'formData'}).then(() => {
    isShowHisFile.value = false
    isShowHisPo.value = false
    isShowHisDelivery.value = false
    ElMessage.success('引用成功')
    formatOrderFiles(currentOrderRow)
    // 清空多选
    clearTableHandle()
  }).finally(() => {
    isRefLoading.value = false
  })
}

const isShowEdit = ref<boolean>(false)
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()
const valueHtml = ref<string>('')

const toolbarConfig = {
  toolbarKeys: ['bold', 'italic', 'underline', '|', 'justifyLeft', 'justifyCenter', 'justifyRight', '|', 'insertLink', 'uploadImage']
}
const editorConfig = { 
  placeholder: '请输入内容...',
  'MENU_CONF': {
    uploadImage: {
      // base64LimitSize: 100 * 1024 * 1024 
      // base64LimitSize: 0,
      async customUpload(file: any, insertFn: any) {  // TS 语法
        deliveryUpload_fileApi({
          files: file
        }, {contentType: 'formData'}).then(({url, fileId}) => {

          insertFn(url, fileId)
        })
        
    }
    }
  }
}

const handleCreated = (editor: string) => {
  editorRef.value = editor // 记录 editor 实例
}

let currentNote = ref<string>('')
const editHandle = (_order: any, note: string) => {
  currentNote.value = note
  valueHtml.value = _order[note]
  isShowEdit.value = true
  Object.assign(currentOrder, _order)
  currentOrderRow = _order
}

const submitEdit = () => {
  cancelTk = axiosInstance.CancelToken.source();
  const text = valueHtml.value === '<p><br></p>' ? '' : valueHtml.value

  const form: any = new FormData()
  form.append('no', currentOrder.no)
  if(currentNote.value === 'sourceFileNote'){
    form.append('deliveryFileType', 'SOURCE_FILE')
  }
  if(currentNote.value === 'poFileNote'){
    form.append('deliveryFileType', 'PO_FILE')
  }
  if(currentNote.value === 'deliveryNote'){
    form.append('deliveryFileType', 'DELIVERY_FILE')
  }
  form.append(currentNote.value, text)
  uploadApi(form).then(() => {
    ElMessage.success('编辑成功')
    isShowEdit.value = false
    currentOrderRow[currentNote.value] = text
    formatOrderFiles(currentOrderRow)
  })
}




onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const isShowTip = ref<boolean>(false)
const tipStr = ref<string>('')

let orderNoArr = ref([])
let resolveFn = ref()
let rejectFn = ref()

const deliveryOrderHandle = () => {
  tipStr.value = ''
  orderNoArr.value = []

  props.orderList.forEach((order: any, orderIndex) => {
    let {sourceFiles, sourceFileNote, poFiles, deliveryFiles, deliveryNote, poFileNote, poNumber} = order
    let str = []

    // 判断源文件是否为空
    if(sourceFiles.length === 0 && (!sourceFileNote || sourceFileNote === '<p><br></p>')){
      str.push('【源文件】')
    }
    // 有po号才需要备注或者上传po文件
    if(poNumber && poFiles.length === 0 && (!poFileNote || poFileNote === '<p><br></p>')){
      str.push('【po文件】')
    }
    if(deliveryFiles.length === 0 && (!deliveryNote || deliveryNote === '<p><br></p>')){
      str.push('【交付凭证】')
    }
    if(str.length !== 0){
      tipStr.value += `订单${orderIndex + 1}（${order.no}） 未上传` + str.join('、') + '\n'
      return false
    } else {
      orderNoArr.value.push(order.no)
    }
  })

  
  if(tipStr.value.length !== 0){
    isShowTip.value = true
    return new Promise((resolve, reject) => {
      resolveFn.value = resolve
      rejectFn.value = reject
    })
  } else {
    return Promise.resolve(orderNoArr.value)
  }
  
}

expose({
  deliveryOrderHandle,
})

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderList, (order, orderIndex) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_descriptions, {
          title: `订单${orderIndex + 1}（${order.no}） -- ${props.isEdit ? '交付详情': '基本信息'}`,
          column: 6,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "客户名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.customerUsername), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "客户联系人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.customerContacter), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "订单状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.status), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "订单号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.no), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "订单名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.name), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "CM" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.cm), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "PM" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.pm), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "AM" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.am), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "USD金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.baseCurrencyMoney), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "原币别" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.currency), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "原金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(order.amount), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_descriptions_item, { label: "成本" })
          ]),
          _: 2
        }, 1032, ["title"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_row, { class: "mt-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("p", _hoisted_2, [
                    _hoisted_3,
                    (!props.isEdit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "上传"))
                      : _createCommentVNode("", true),
                    _hoisted_5,
                    (props.orderList.length > 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (showHisFileHandle(order))
                        }, _hoisted_10, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "editInput",
                    onClick: ($event: any) => (editHandle(order, 'sourceFileNote'))
                  }, "若无源文件，点击输入原因", 8, _hoisted_11),
                  _createVNode(_component_el_button, {
                    icon: "Upload",
                    onClick: ($event: any) => (showUpFileHandle(order)),
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_table, {
                    data: order.sourceFiles,
                    "max-height": "300"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "文件名",
                        prop: "file.filename"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        width: "80"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (delFileHandle(order, row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, [
                    _hoisted_16,
                    (!props.isEdit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "上传"))
                      : _createCommentVNode("", true),
                    _hoisted_18,
                    (props.orderList.length > 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (showHisPoHandle(order))
                        }, _hoisted_23, 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "editInput",
                    onClick: ($event: any) => (editHandle(order, 'poFileNote'))
                  }, "若无PO文件，点击输入原因", 8, _hoisted_24),
                  _createVNode(_component_el_button, {
                    icon: "Upload",
                    onClick: ($event: any) => (showUpPoHandle(order)),
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_table, {
                    data: order.poFiles,
                    "max-height": "300"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "文件名",
                        prop: "file.filename"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        width: "80"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (delFileHandle(order, row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, [
                    _hoisted_29,
                    (!props.isEdit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "上传"))
                      : _createCommentVNode("", true),
                    _hoisted_31
                  ]),
                  (props.orderList.length > 1 && orderIndex === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: isAllQuote.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAllQuote).value = $event)),
                          label: "全部引用",
                          onChange: ($event: any) => (showHisDeliveryHandle(order))
                        }, null, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: "勾选后，下面的所有订单全部直接引用此订单的交付凭证",
                          placement: "top-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "editInput",
                    onClick: ($event: any) => (editHandle(order, 'deliveryNote'))
                  }, "填写交付凭证或直接上传附件", 8, _hoisted_33),
                  _createVNode(_component_el_button, {
                    icon: "Upload",
                    onClick: ($event: any) => (showDeliverHandle(order)),
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_table, {
                    data: order.deliveryFiles,
                    "max-height": "300"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "文件名",
                        prop: "file.filename"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        width: "80"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (delFileHandle(order, row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)), [
          [_directive_loading, order.isLoading === true]
        ])
      ]))
    }), 256)),
    _createVNode(_component_el_dialog, {
      title: "上传源文件",
      modelValue: isShowUpFile.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowUpFile).value = $event)),
      width: "700px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowUpFile.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (upFileHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (isShowUpFile.value)
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              drag: "",
              action: "",
              multiple: "",
              "auto-upload": false,
              "file-list": _unref(currentOrder).sourceFiles,
              "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => ((_unref(currentOrder).sourceFiles) = $event)),
              ref: "upload"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_filled)
                  ]),
                  _: 1
                }),
                _hoisted_36
              ]),
              _: 1
            }, 8, ["file-list"]))
          : _createCommentVNode("", true),
        (upPercentage.value > 0)
          ? (_openBlock(), _createBlock(_component_el_progress, {
              key: 1,
              percentage: upPercentage.value
            }, null, 8, ["percentage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "上传PO文件",
      modelValue: isShowUpPo.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowUpPo).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (isShowUpPo.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (upPoHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (isShowUpPo.value)
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              drag: "",
              action: "",
              multiple: "",
              "auto-upload": false,
              "file-list": _unref(currentOrder).poFiles,
              "onUpdate:file-list": _cache[5] || (_cache[5] = ($event: any) => ((_unref(currentOrder).poFiles) = $event)),
              ref: "upload"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_filled)
                  ]),
                  _: 1
                }),
                _hoisted_39
              ]),
              _: 1
            }, 8, ["file-list"]))
          : _createCommentVNode("", true),
        (upPercentage.value > 0)
          ? (_openBlock(), _createBlock(_component_el_progress, {
              key: 1,
              percentage: upPercentage.value
            }, null, 8, ["percentage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "上传交付凭证",
      modelValue: isShowDeliver.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isShowDeliver).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (isShowDeliver.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_43
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (upDeliverHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (isShowDeliver.value)
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              drag: "",
              action: "",
              multiple: "",
              "auto-upload": false,
              "file-list": _unref(currentOrder).deliveryFiles,
              "onUpdate:file-list": _cache[9] || (_cache[9] = ($event: any) => ((_unref(currentOrder).deliveryFiles) = $event)),
              ref: "upload"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_filled)
                  ]),
                  _: 1
                }),
                _hoisted_42
              ]),
              _: 1
            }, 8, ["file-list"]))
          : _createCommentVNode("", true),
        (upPercentage.value > 0)
          ? (_openBlock(), _createBlock(_component_el_progress, {
              key: 1,
              percentage: upPercentage.value
            }, null, 8, ["percentage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "富文本编辑器",
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowEdit).value = $event)),
      onClose: _cache[17] || (_cache[17] = ($event: any) => (_unref(editorRef).clear()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (isShowEdit.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_45
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (submitEdit()))
        }, {
          default: _withCtx(() => [
            _hoisted_46
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Toolbar), {
          style: {"border-bottom":"1px solid #ccc"},
          editor: _unref(editorRef),
          defaultConfig: toolbarConfig,
          mode: "simple"
        }, null, 8, ["editor"]),
        _createVNode(_unref(Editor), {
          style: {"height":"500px","overflow-y":"hidden"},
          modelValue: valueHtml.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((valueHtml).value = $event)),
          defaultConfig: editorConfig,
          mode: "simple",
          onOnCreated: handleCreated
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowHisFile.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((isShowHisFile).value = $event)),
      title: "已上传的源文件",
      onClose: _cache[21] || (_cache[21] = ($event: any) => (clearTableHandle()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (isShowHisFile.value = false)),
          disabled: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_52
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (confirmReference('sourceFileIds'))),
          loading: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderList, (order, orderIndex) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_47, [
            (order.no !== _unref(currentOrder).no)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  border: "",
                  data: order.sourceFiles || [],
                  ref_for: true,
                  ref: setTbRef,
                  onSelectionChange: (rows) => referenceRowsChange(rows, orderIndex)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "50",
                      selectable: (row) => !_unref(currentOrder).sourceFiles?.map((e) => e.deliveryValue).includes(row.deliveryValue)
                    }, null, 8, ["selectable"]),
                    _createVNode(_component_el_table_column, {
                      label: '订单' + (orderIndex + 1),
                      align: "center",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "源文件名称",
                          prop: "file.filename",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "文件大小",
                          width: "110",
                          align: "center"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(_unref(formatFileSize)(row.file.size)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1032, ["data", "onSelectionChange"]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_48,
        _hoisted_49,
        _hoisted_50,
        _hoisted_51
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowHisPo.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((isShowHisPo).value = $event)),
      title: "已上传的PO文件",
      onClose: _cache[25] || (_cache[25] = ($event: any) => (clearTableHandle()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (isShowHisPo.value = false)),
          disabled: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_59
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (confirmReference('poFileIds'))),
          loading: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_60
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderList, (order, orderIndex) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_54, [
            (order.no !== _unref(currentOrder).no)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  border: "",
                  data: order.poFiles || [],
                  ref_for: true,
                  ref: setTbRef,
                  onSelectionChange: (rows) => referenceRowsChange(rows, orderIndex)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "50",
                      selectable: (row) => !_unref(currentOrder).poFiles?.map((e) => e.deliveryValue).includes(row.deliveryValue)
                    }, null, 8, ["selectable"]),
                    _createVNode(_component_el_table_column, {
                      label: '订单' + (orderIndex + 1),
                      align: "center",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "PO文件名称",
                          prop: "file.filename",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "文件大小",
                          width: "110",
                          align: "center"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(_unref(formatFileSize)(row.file.size)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1032, ["data", "onSelectionChange"]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_55,
        _hoisted_56,
        _hoisted_57,
        _hoisted_58
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowHisDelivery.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((isShowHisDelivery).value = $event)),
      title: "已上传的交付凭证",
      onClose: _cache[29] || (_cache[29] = ($event: any) => (clearTableHandle()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[26] || (_cache[26] = ($event: any) => (isShowHisDelivery.value = false)),
          disabled: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_66
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[27] || (_cache[27] = ($event: any) => (confirmReference('deliveryIds'))),
          loading: isRefLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_67
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderList, (order, orderIndex) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_61, [
            (order.deliveryFiles && order.no !== _unref(currentOrder).no)
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  border: "",
                  data: order.deliveryFiles || [],
                  ref_for: true,
                  ref: setTbRef,
                  onSelectionChange: (rows) => referenceRowsChange(rows, orderIndex)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "50",
                      selectable: (row) => !_unref(currentOrder).deliveryFiles?.map((e) => e.deliveryValue).includes(row.deliveryValue)
                    }, null, 8, ["selectable"]),
                    _createVNode(_component_el_table_column, {
                      label: '订单' + (orderIndex + 1),
                      align: "center",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "交付凭证名称",
                          prop: "file.filename",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "文件大小",
                          width: "110",
                          align: "center"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(_unref(formatFileSize)(row.file.size)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1032, ["data", "onSelectionChange"]))
              : _createCommentVNode("", true)
          ]))
        }), 256)),
        _hoisted_62,
        _hoisted_63,
        _hoisted_64,
        _hoisted_65
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "提示",
      modelValue: isShowTip.value,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((isShowTip).value = $event)),
      width: "490px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[30] || (_cache[30] = ($event: any) => {_unref(rejectFn)(); isShowTip.value = false})
        }, {
          default: _withCtx(() => [
            _hoisted_74
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[31] || (_cache[31] = ($event: any) => {_unref(resolveFn)(_unref(orderNoArr)); isShowTip.value = false})
        }, {
          default: _withCtx(() => [
            _hoisted_75
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, _toDisplayString(tipStr.value), 1),
        _hoisted_69,
        _hoisted_70,
        _hoisted_71,
        _hoisted_72,
        _hoisted_73
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, isListLoading.value]
  ])
}
}

})